import type { ProxyBand } from './mockProxyJobs';

export interface ProxyReportDefinition {
  id: string;
  title: string;
  description: string;
  band: ProxyBand | 'All';
}

// A growing list — add an entry here to register another named report.
// Reports are static outstanding-material snapshots by cutoff band; they
// never spawn tasks on their own. The only action available from a report
// row is "Create follow-up," which hands one specific job to Ace's
// MATERIAL_FOLLOWUP workflow (see data/workflows/materialFollowupWorkflow.ts).
export const PROXY_REPORTS: ProxyReportDefinition[] = [
  {
    id: 'outstanding-all',
    title: 'All outstanding',
    description: 'Every job still owed material, soonest vote cutoff first, with what the procedure says to do next.',
    band: 'All',
  },
  {
    id: 'outstanding-red',
    title: 'Outstanding Material: Red',
    description: '1 to 18 days to the meeting (ICT-8). At 18 to 11 days to vote cutoff, search EDGAR/SEDAR first. If the filing is found, release emails only. If not, send a Red follow-up. At 10 days or fewer the cutoff rules engine calls for POD, email-only/cancel full sets, or abort.',
    band: 'Red',
  },
  {
    id: 'outstanding-yellow',
    title: 'Outstanding Material: Yellow',
    description: '19 to 30 days to the meeting (ICT-1). Follow up with the solicitor of record, or send the Issuer follow-up when none is on record.',
    band: 'Yellow',
  },
  {
    id: 'outstanding-green',
    title: 'Outstanding Material: Green',
    description: 'More than 30 days to the meeting. Comfortably on track, so just monitor it.',
    band: 'Green',
  },
];
